import createHash from 'create-hash';

export default function hashSha256(string) {
  return createHash('sha256').update(string).digest('base64');  
};
